export default class Utils {
  public static sanitizeInput(value: string) {
    return value.replace(/[\\'"&<>`;]/g, '');
  }

  static isInEpiserverEditMode(): boolean {
    const htmlTags = document.querySelectorAll('html');
    let isInEditMode = false;
    htmlTags.forEach((htmlElement: HTMLElement) => {
      if (htmlElement.hasAttribute('editmode')) {
        isInEditMode = true;
      }
    });
    return isInEditMode;
  }

  public static findClosest(element: HTMLElement, cssClass: string): HTMLElement | undefined {
    let closest = element;
    while (closest) {
      if (closest.classList.contains(cssClass)) {
        return closest;
      }
      if (closest.parentElement === null) {
        return undefined;
      }
      closest = closest.parentElement;
    }
    return undefined;
  }
}
